import tables from './tables';
import utils from '../utils';
import { CommonLogger } from '../logger';

const setLaunchLinkParams = async (data, token) => {
  const { id } = data;

  try {
    await utils.postToMikMakFirebaseService(`set/${tables.launchLinkParams}/${id}`, data, token);

    return data;
  } catch (e) {
    CommonLogger.error(`Error saving link params to Firebase for Data Id: ${id}`, { dataId: id });

    throw `Error saving link params to Firebase for Data Id: ${id}. ${e}`;
  }
};

const updateLaunchLinkParams = async (data, token) => {
  try {
    const { id } = data;

    await utils.postToMikMakFirebaseService(`update/${tables.launchLinkParams}/${id}`, data, token);

    return data;
  } catch (e) {
    throw `Error updating live player param: ${e}`;
  }
};

const getLaunchLinkParamsByBrandId = async (brandId, token) => {
  try {
    const { data: launchLinkParams } = await utils.getFromMikMakFirebaseService(
      `get/${tables.launchLinkParams}?orderBy=brandId&equalTo=${brandId}`,
      token,
    );

    return launchLinkParams;
  } catch (e) {
    throw `Error getting saved Launch Link Params for brand ${brandId}:${e}`;
  }
};

const getLaunchLinkParamsByPlayerId = async (playerId, token) => {
  try {
    const { data: launchLinkParams } = await utils.getFromMikMakFirebaseService(
      `get/${tables.launchLinkParams}?orderBy=playerId&equalTo=${playerId}`,
      token,
    );

    return launchLinkParams;
  } catch (e) {
    throw `Error getting saved Launch Link Params for player ${playerId}:${e}`;
  }
};

export default {
  setLaunchLinkParams,
  getLaunchLinkParamsByBrandId,
  getLaunchLinkParamsByPlayerId,
  updateLaunchLinkParams,
};
